<template>
	<div
		class="d-flex align-center space-between tab-container"
		:style="`border-bottom:0.1rem solid ${globalColors.titulo};border-top:0.1rem solid ${globalColors.titulo}`"
	>
		<button
			type="button"
			v-for="(item, index) in filters"
			:key="index"
			:class="[
				'flex-auto',
				'h-100',
				'bgWhite',
				'btn-item',
			]"
			:style="`background-color:${item.active ? globalColors.primary : 'white'};color:${item.active ? 'white' : globalColors.titulo}`"
			@click="onClick(item)"
			@mouseover="onMouseOver(item)"
		>{{item.title}}</button>
	</div>
</template>
<script>

function created() {
	this.loadData();
}

async function loadData() {
	({ data: this.filters } = await this.$httpQtc.get('filters-public'));
}

function onMouseOver(item) {
	this.filters = this.filters.reduce((list, currentItem) => {
		const newCurrentItem = { ...currentItem };
		newCurrentItem.active = false;
		if (newCurrentItem.title === item.title) {
			newCurrentItem.active = true;
			this.currentFilter = { ...newCurrentItem };
		}
		return list.concat(newCurrentItem);
	}, []);
}
function onClick(item) {
	this.onMouseOver(item);
	this.setLocalData('filter-products', this.currentFilter);
	this.$router.push({ name: 'filters', params: { id: item.id } });
}

function data() {
	return {
		currentFilter: {},
		filters: [],
	};
}

export default {
	name: 'tab',
	created,
	data,
	methods: {
		loadData,
		onClick,
		onMouseOver,
	},
};
</script>
<style lang="scss" scoped>
	.tab-container {
		height: 5.7rem;
		width: 100%;

		@media (max-width: 475px) {
			display: none;
		}
	}

	.btn-item {
		border: none;
	}
</style>





// WEBPACK FOOTER //
// tab.vue?710493c2